// eslint-disable-next-line import/prefer-default-export
export const USER_TYPE = {
  C0001: "本部",
  C0002: "店舗",
  C0003: "得意先",
  C0004: "仕入先",
  C0005: "倉庫", // 自社倉庫
  C0006: "企業",
  C0007: "伊藤忠倉庫",
  C0008: "昭和製氷倉庫",
  C0009: "ジョイフル"
};

export const USER_TYPE_LIST = {
  "headquarters": {
    value: Object.keys(USER_TYPE)[0],
    text: USER_TYPE[Object.keys(USER_TYPE)[0] as keyof typeof USER_TYPE],
  },
  "store": {
    value: Object.keys(USER_TYPE)[1],
    text: USER_TYPE[Object.keys(USER_TYPE)[1] as keyof typeof USER_TYPE],
  },
  "customer": {
    value: Object.keys(USER_TYPE)[2],
    text: USER_TYPE[Object.keys(USER_TYPE)[2] as keyof typeof USER_TYPE],
  },
  "supplier": {
    value: Object.keys(USER_TYPE)[3],
    text: USER_TYPE[Object.keys(USER_TYPE)[3] as keyof typeof USER_TYPE],
  },
  "warehouse": {
    value: Object.keys(USER_TYPE)[4],
    text: USER_TYPE[Object.keys(USER_TYPE)[4] as keyof typeof USER_TYPE],
  },
  "company": {
    value: Object.keys(USER_TYPE)[5],
    text: USER_TYPE[Object.keys(USER_TYPE)[5] as keyof typeof USER_TYPE],
  },
  "itochu": {
    value: Object.keys(USER_TYPE)[6],
    text: USER_TYPE[Object.keys(USER_TYPE)[6] as keyof typeof USER_TYPE],
  },
  "showa": {
    value: Object.keys(USER_TYPE)[7],
    text: USER_TYPE[Object.keys(USER_TYPE)[7] as keyof typeof USER_TYPE],
  },
  "joyful": {
    value: Object.keys(USER_TYPE)[8],
    text: USER_TYPE[Object.keys(USER_TYPE)[8] as keyof typeof USER_TYPE],
  }
}